import * as utils from "./misc.js";
// import * as page from "./page.js";
//import * as woocommerce from "./woocommerce.js";

export function init() {

    get_user(true);

    jQuery(".loginform input[name='login']").on("click", function (e) {
        login(jQuery(this));
    })

    jQuery("body").on("click", ".ajaxlogout", function () {
        logout();
    })

}

export function get_user(refresh = false) {

    console.log("get_user: ", refresh);

    const url = utils.getCurrentURL();

    if (url.indexOf("profem") <= -1) { return; }
    // get user details if we have a cookie or if we are forcing a refresh
    var userDetails = utils.getCookie("cc_ud");


    if (!userDetails || refresh) {
        //utils.log("get user from ajax");
        jQuery.post(base.ajaxurl, {
            action: "get_userdetails",
            pageid: base.currentpageid,
            pagenonce: base.pagenonce
        }, function (r) {
            utils.setCookie("cc_ud", encodeURIComponent(JSON.stringify(r)));
            userLoggedIn(r);
        });
    }
    else {
        //utils.log("get user from cookie");
        var r = JSON.parse(decodeURIComponent(userDetails))

        userLoggedIn(r);
    }


}

export function isLoggedIn() {
    if (utils.getCookie("ccusercode")) {
        return true
    }
    else {

        return false
    }
}


export function userLoggedIn(userDetails) {

    var userDetails = JSON.parse(decodeURIComponent(userDetails))
    var username = userDetails.username;
    if (username == "Not Logged In") {
        userNotLoggedIn();
    }
    else {

        jQuery("header .icons").prepend(`<div class='welcomeback'>Welcome Back ${username}</div>`);
        jQuery("body").addClass("logged-in");
        // jQuery("header .minilogin .myaccount_wrapper").show();
        // jQuery("header .minilogin .loginform_wrapper").hide();
    }
    //console.log("user is logged in: ", userDetails);

}

export function userNotLoggedIn() {

    jQuery("body").removeClass("logged-in");
    // jQuery("header .minilogin").show();
    // jQuery("header .welcomeback").hide();
    // jQuery("header .minilogin .myaccount_wrapper").hide();
    // jQuery("header .minilogin .loginform_wrapper").show();
}

export function resetpassword() {

    var emailval = jQuery(".emailaddressrow input[name='email']").val();
    var passwordval = jQuery(".passwordrow input[name='password']").val();
    var passwordval2 = jQuery(".repeatpassword input[name='password2']").val();
    var key = jQuery("button[name='resetpassword']").attr("data-k");

    jQuery(".emailaddressrow input[name='email']").removeClass("error");
    jQuery(".passwordrow input[name='password']").removeClass("error");
    jQuery(".repeatpassword input[name='password2']").removeClass("error");
    jQuery(".passwordresult").remove();

    if (passwordval != passwordval2) {
        jQuery(".passwordrow input[name='password']").addClass("error");
        jQuery(".repeatpassword input[name='password2']").addClass("error");
        jQuery(".resetpasswordform .form .text").append("<div class='passwordresult error'>Your passwords don't match</div>")
    }
    if (emailval != "" && passwordval != "" && passwordval2 != "" && key != "") {
        jQuery.post(
            base.ajaxurl,
            {
                action: "resetpassword",
                email: emailval,
                password: passwordval,
                password2: passwordval2,
                key: key
            },
            function (response) {

                var r = JSON.parse(response);
                if (r.errors == "emailnotfound") {
                    jQuery(".resetpasswordform .form .text").html("Please check your registered email address is correct")
                    jQuery(".emailaddressrow input[name='email']").addClass("error");

                }
                if (r.status == "done") {
                    jQuery(".resetpasswordform h3").html("Thank You");
                    jQuery(".resetpasswordform .form").html("Your password has been reset!");
                }
            }
        );
    }

}

export function logout() {
    jQuery.post(
        base.ajaxurl,
        {
            action: "logout"
        },
        function (response) {

            var r = JSON.parse(response);

            if (r.success == "done") {
                utils.eraseCookie("cc_ud");
                userNotLoggedIn();
            }
        }
    );
}


export function login(btn) {
    var username;

    var usernamefield = btn.closest('div').find("input[name='username']").show();
    var passwordfield = btn.closest('div').find("input[name='password']").show();

    usernamefield.removeClass("error");
    passwordfield.removeClass("error");
    jQuery(".loginresult").html("");
    btn.val("please wait");
    if (usernamefield.val() == "") {
        usernamefield.addClass("error");
        btn.val("Login");
    }
    else if (passwordfield.val() == "") {
        passwordfield.addClass("error");
        btn.val("Login");
    }
    else {
        jQuery.post(base.ajaxurl, {
            action: "wp_login",
            email: usernamefield.val(),
            password: passwordfield.val()
        }, function (r) {
            var result = JSON.parse(r);
            var errormessage = result.errormessage ? result.errormessage : "";
            if (errormessage !== "") {
                btn.val("Login");
                jQuery(".loginresult").html(errormessage);
            }
            else {

                userLoggedIn(r);
                //username = r.username;
                //get_user(true);
            }
        });
    }
}